import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  useTheme,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import { useFormRCAutoDetails } from "../rcautoContext";
import { NumericFormat } from "react-number-format";
import { DatePicker } from "@mui/x-date-pickers";
import { parseDate } from "../../rcAutoDetails2/helpers";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { API_BASE_URL } from "../../../../config";
import { showSnackbar } from "../../../../redux/slices/snackbar";

const formatDate = (date) => {
  if (!date) return "";
  if (typeof date === "string" && date.includes("/")) return date;
  // Accepts Date object
  const d = new Date(date);
  if (isNaN(d)) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const ModificaDialog = ({ open, onClose, idUID, type }) => {
  const { formState, dispatch } = useFormRCAutoDetails();
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatchSnackbar = useDispatch();
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  const data = formState.preventivi?.[type]?.find((p) => p.idUID === idUID);

  const [localData, setLocalData] = useState({
    tariffaAnnuale: 0,
    tariffa: 0,
    dataDecorrenza: null,
    scadenzaLibroMatricola: null,
  });

  useEffect(() => {
    if (data && open) {
      setLocalData({
        tariffa: 0,
        tariffaAnnuale: data.dettagli?.tariffaAnnuale || 0,
        dataDecorrenza: data.ratino?.dataDecorrenza
          ? parseDate(data.ratino.dataDecorrenza)
          : null,
        scadenzaLibroMatricola: data.ratino?.scadenzaLibroMatricola
          ? parseDate(data.ratino.scadenzaLibroMatricola)
          : null,
      });
    }
  }, [data, open]);

  const handleSave = async () => {
    if (!data) return;

    const updatedPreventivo = {
      ...data,
      dettagli: {
        ...data.dettagli,
        tariffaAnnuale: Number(localData.tariffa),
      },
    };
    console.log(updatedPreventivo);
    if (data.ratino && Object.keys(data.ratino).length > 0) {
      updatedPreventivo.ratino = {
        ...data.ratino,
        dataDecorrenza: localData.dataDecorrenza
          ? formatDate(localData.dataDecorrenza)
          : data.ratino.dataDecorrenza,
        scadenzaLibroMatricola: localData.scadenzaLibroMatricola
          ? formatDate(localData.scadenzaLibroMatricola)
          : data.ratino.scadenzaLibroMatricola,
      };
    }

    const endpoint = `${API_BASE_URL}/api/rcAuto/${updatedPreventivo?.idUID}/pricing/calculate`;

    delete updatedPreventivo?.idUID;

    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          data: updatedPreventivo,
        }),
      };

      const response = await fetch(endpoint, requestOptions);
      const res = await response.json();

      if (res.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
        handleSnackbar(res.message, "error");
      } else if (res.status === 0) {
        // navigate("/private");
        handleSnackbar(res.message, "error");
        return;
      } else {
        const newPreventivoData = res[0];
        dispatch({
          type: "update_preventivo",
          payload: {
            typePrev: type,
            idUID: idUID,
            preventivo: newPreventivoData,
          },
        });
        handleSnackbar("Ricalcolo effettuato con successo", "success");
        onClose();
      }
    } catch (e) {
      console.log(e);
      handleSnackbar("Errore durante il ricalcolo", "error");
    }
  };

  const hasRatino = data?.ratino && Object.entries(data.ratino).length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px",
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Modifica preventivo</DialogTitle>
      <DialogContent>
        <Stack spacing={4}>
          <Box display="flex" gap={2} alignItems="start" flexDirection="column">
            <Box>
              <Typography>Tariffa</Typography>
            </Box>
            <Box display="flex" gap={2}>
              <NumericFormat
                customInput={TextField}
                label="Tariffa Attuale"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fullWidth
                value={localData.tariffaAnnuale}
                disabled
              />
              <NumericFormat
                customInput={TextField}
                label="Nuova Tariffa"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fullWidth
                value={localData.tariffa}
                onValueChange={(values) => {
                  setLocalData((prev) => ({ ...prev, tariffa: values.value }));
                }}
              />
            </Box>
          </Box>
          {hasRatino && (
            <Box display="flex" gap={2} flexDirection="column">
              <Box>
                <Typography>Ratino</Typography>
              </Box>
              <Box display="flex" gap={2} alignItems="start">
                <DatePicker
                  label="Data Decorrenza"
                  value={localData.dataDecorrenza}
                  onChange={(date) =>
                    setLocalData((prev) => ({ ...prev, dataDecorrenza: date }))
                  }
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
                <DatePicker
                  label="Scadenza Libro Matricola"
                  value={localData.scadenzaLibroMatricola}
                  onChange={(date) =>
                    setLocalData((prev) => ({
                      ...prev,
                      scadenzaLibroMatricola: date,
                    }))
                  }
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Box>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
        <Button
          variant="contained"
          disabled={!localData.tariffa || localData.tariffa === 0}
          onClick={handleSave}
        >
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModificaDialog;
